export default "__VITE_ASSET__BDD84M_r__"